"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Option_1 = require("fp-ts/es6/Option");
var Either_1 = require("fp-ts/es6/Either");
var lodash_1 = require("lodash");
// Given a path and an object, returns a Option of the value at that path in the object.
exports.optionGet = function (p) {
  return function (obj) {
    return Option_1.fromNullable(lodash_1.get(obj, p, undefined));
  };
};
exports.optionFind = function (f, arr) {
  return Option_1.fromNullable(arr.find(f));
};
exports.propE = function (key) {
  return function (obj) {
    if (key in obj) {
      return Either_1.right(obj[key]);
    }
    return Either_1.left("Could not find " + key + " in " + JSON.stringify(obj));
  };
};